// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Loading from '../Icons/loading.gif'
import Paginate from '../Buttons/Paginate'
import './NotificationsUsersTable.css'
import InfoIcon from '../../Shared/Icons/icon-info-grey.svg'

type Props = {
  changeOffset: Function,
  data: Array,
  fields: Array,
  page: number,
  totalUsers: number,
  title: string,
  tooltipText: string
}

const HeaderTitle = styled.span`
  float: left;
  font-size: 20px;
  padding: 17px 15px 25px 23px;
`
/**
  * Diplay for user table
  * @class
  * @extends Component
*/
class NotificationUsersTable extends Component<Props> {
  /** render function */
  render () {
    const fields = this.props.fields
    const headers = fields.map((field, index) =>
      <th
        key={index}
      >
        <span>{field.title}</span>
      </th>)
    const users = this.props.data.map((user, i) => {
      if (user.name === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (user.name === '') {
        return false // removes users from list that does not have name
      } else {
        return (
          <tr key={i}>{fields.map((field) => {
            if (field.ref === 'name') {
              return (<td key={field.ref}><Link to={{ pathname: '/user', search: '?id=' + user._id + '&date=Week&filter=__' }}>{user[field.ref] || '--'} </Link></td>)
            } else if (field.toMap) {
              return (<td key={field.ref}> {field.toMap(user[field.ref]) || '--'}</td>)
            } else if (field.ref === 'appProfiles') {
              if (user[field.ref].length > 1) {
                return <td key={field.ref}><ul>
                  {user[field.ref].map(profile => {
                    return <li key={Math.random()}>{profile}</li>
                  })}
                </ul></td>
              } else {
                return <td key={field.ref}>{user[field.ref]}</td>
              }
            }
            return (
              <td key={field.ref}>{user[field.ref] || '--'} </td>
            )
          })}</tr>
        )
      }
    }
    )
    return (
      <div>
        <div className='table-wrapper'>
          <div className='NotificationUsersTable'>
            <div className='flex align-center'>
              <HeaderTitle>{this.props.title}</HeaderTitle>
              <div className='tooltip'>
                <span><img className='icon-md' src={InfoIcon} alt={InfoIcon} /></span>
                <span className='tooltipText'>{this.props.tooltipText}</span>
              </div>
            </div>
            <table>
              <thead><tr>{headers}</tr></thead>
              <tbody>
                {users}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalUsers} />
      </div>
    )
  }
}

export default NotificationUsersTable
